import * as React from 'react';
import { BlockProps } from '../index.types';
import PageSection from 'components/page/page-section';
import Text, { TextType, TextTagName } from 'components/typography/text';

export const mapLevelToSectionTitleType: Record<number, TextType> = {
    1: TextType.H1,
    2: TextType.H2,
    3: TextType.H3,
    4: TextType.H4,
};

export const mapLevelToTextTagName: Record<number, TextTagName> = {
    1: TextTagName.h1,
    2: TextTagName.h2,
    3: TextTagName.h3,
    4: TextTagName.h4,
};

const DEFAULT_SectionTitle_STYLE = TextType.H2;

export function SectionTitle({ block: { innerHTML }, level }: BlockProps) {
    let tagName;

    if (level) {
        tagName = mapLevelToTextTagName[level];
    } else {
        /**
         * default level for WP
         */
        tagName = mapLevelToTextTagName[2];
    }

    return innerHTML ? (
        <PageSection hasPadding={true}>
            <div className="flex h-center v-center">
                <div className="content">
                    <Text
                        type={
                            (level && mapLevelToSectionTitleType[level]) ||
                            DEFAULT_SectionTitle_STYLE
                        }
                        isResponsive={true}
                        html={innerHTML}
                        tagname={tagName}
                        extraClass="black weight-black center-align"
                    />
                </div>
            </div>
        </PageSection>
    ) : null;
}
